module.exports = __webpack_public_path__ + "static/media/app.b8bcb440.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/gifs/app.gif
// module id = 66
// module chunks = 0